import axios from '../request/http.js'
import { handleGetRequestParams } from '../common/js/utils.js'

class Troubleshooting {
  /* 疑难解答 */
  static getTroubleshootingList(options) {
    let url = `/zzd/api/back/regulation/comment/page?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 回复 */
  static postReply(data) {
    let url = `/zzd/api/back/regulation/comment/reply`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 设为精选/取消精选 */
  static postSetSelectedOrConcalSelected(data) {
    let url = `/zzd/api/back/regulation/comment/select`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default Troubleshooting